module.exports = __webpack_public_path__ + "img/撇嘴.20a5c0ff.png";